import styled from 'styled-components';
const RunIcon = styled.i`
  margin-right: 6.51px;
  font-size: 8.35px;
`;
export default RunIcon;